import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditarCategoria.css";
const API = process.env.REACT_APP_API_URL;

export default function EditarCategoria() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch(API + "/user/refresh",{
         method:"POST",
          credentials: "include",

      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const [categoria, setCategoria] = useState({
    id: "",
    nombre: "",
    descripcion: ""
  });

  const [cargando, setCargando] = useState(false);

  // 🔹 Traer categoría por ID
  const obtenerCategoriaId = async () => {
    try {
      const response = await fetch(
        `${API}/categorias/obtenerCategoriaId/${id}`,
        {
          headers: { Authorization: `Bearer ${token}`}
        }
      );

      if(response.status === 403 && await renovarToken())return;

      if (!response.ok) throw new Error();

      const data = await response.json();

      setCategoria({
        id: data.datos.id,
        nombre: data.datos.nombre,
        descripcion: data.datos.descripcion
      });

    } catch (error) {
      console.log("❌ No se pudo traer la categoría");
    }
  };

  useEffect(() => {
    obtenerCategoriaId();
  }, []);

  // 🔹 Guardar cambios
  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    try {
      const response = await fetch(
      API +  "/categorias/ActualizarCategoria",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(categoria)
        }
      );


      if(response.status === 403 && await renovarToken())return;

      if (!response.ok) throw new Error();

      alert("Categoría actualizada correctamente ✅");
      navigate("/categorias");

    } catch (error) {
      alert("❌ Error al actualizar la categoría");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="admin-container">
      <header className="form-header">
        <button className="btn-back" onClick={() => navigate(-1)}>
          ← Volver
        </button>
        <h1>Actualizar Categoría</h1>
      </header>

      <main className="form-card">
        <form onSubmit={handleSubmit} className="form-categoria">

          <div className="input-group">
            <label>Nombre de la categoría</label>
            <input
              type="text"
              value={categoria.nombre}
              onChange={(e) =>
                setCategoria({ ...categoria, nombre: e.target.value })
              }
              required
              autoFocus
            />
          </div>

          <div className="input-group">
            <label>Descripción</label>
            <textarea
              rows="5"
              value={categoria.descripcion}
              onChange={(e) =>
                setCategoria({ ...categoria, descripcion: e.target.value })
              }
              required
            />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className={`btn-submit ${cargando ? "loading" : ""}`}
              disabled={cargando}
            >
              {cargando ? "Guardando..." : "Guardar Cambios"}
            </button>
          </div>

        </form>
      </main>
    </div>
  );
}
